<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create Knowlegebase Article</h1>
        </div>

        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="account-sidebar h-full">
                    <div class="mb-4 text-center">
                        <span class="fa-layers fa-4x mb-3">
                            <i class="fa fa-circle"></i>
                            <i class="fas fa-user fa-inverse" data-fa-transform="shrink-6.5"></i>
                        </span>

                        <p class="text-lg font-light">New Article</p>
                    </div>

                    <div class="mb-3">

                    </div>
                </div>

                <div class="account-body">
                    <form class="profile-form">
                        <div class="form-title">
                            <p class="text-lg font-light">Article</p>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="article.kb_title">
                            <label>Title</label>
                        </div>

                        <div class="form-field">
                            <select v-model="article.kb_category">
                                <option
                                    v-for="(category, index) in categories"
                                    :key="index"
                                    :value="category.kcat_id"
                                >{{ category.kcat_title }}
                                </option>
                            </select>
                            <label>Category</label>
                        </div>

                        <div class="form-field">
                            <select v-model="article.kb_active">
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select>
                            <label>Active</label>
                        </div>

                        <div class="form-field styled">
                            <label>Content</label>
                            <Editor
                                :init="{
                                    ...wysiwygOptions,
                                    plugins: wysiwygPlugins
                                }"
                                api-key="kxkhkjfta11crbajh0in2mcap04z7nt4czo9icice5ihpd8n"
                                v-model="article.kb_body"
                                rows="10"
                            >
                            </Editor>
                        </div>

                        <div class="form-field">
                            <select v-model="article.kb_featured">
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select>
                            <label>Featured</label>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="article.kb_featured_precedence">
                            <label>Featured Precedence</label>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
    name: 'KnowledgebaseCreate',
    props: {
        //
    },
    data() {
        return {
            article: {
                kb_title: null,
                kb_body: null,
                kb_category: null,
                kb_active: 0,
                kb_featured: 0,
                kb_featured_precedence: 0,
                kb_container_id: null
            },
            categories: [],
        }
    },
    components: {
        Editor,
    },
    computed: {
        //
    },
    mounted() {
        this.loadData()

        this.setMetaTitle('Create Knowledgebase Article | JournoLink Control')
    },
    beforeDestroy() {
        //
    },
    methods: {
        loadData() {
            axios.get(route('knowledgebase.list'))
                .then(response => {
                    this.categories = response.data.categories
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('List Knowledgebase Articles | JournoLink Control')
            this.$root.goBack()
        },
        /**
         *
         */
        saveForm() {
            this.setContainerId()
            axios.post(route('knowledgebase.create'), this.article)
                .then(response => {
                    this.article = response.data.article
                    this.$bus.$emit('alert.success', 'New article has been created')
                    this.$router.push({name: 'knowledgebase.list', params: {newArticle: this.article}})
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * Set the container ID on save
         *
         * @return {void}
         */
        setContainerId() {
            let category = this.categories.find((cat) => this.article.kb_category == cat.kcat_id)
            this.article.kb_container_id = category.kcat_container_id
        }
    },
}
</script>

<style lang="less">
.account-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.account-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}

.hidden-input {
    input {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }

    .hide {
        display: none;
    }

    .edit-field-link {
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: #222222;
        word-wrap: break-word;
    }
}

.profile-form {
    .section-title {
        margin-top: 20px;
    }

    .form-title {
        margin-bottom: 20px;
    }
}
</style>
